<template lang="pug">
    .questionnaire-snot20
        app-text-field.result-field(
            v-model="result"
            label="Результат"
            is-number
            :max="100"
            :error="error"
            :disabled="disabled"
        )

        app-link(
            @click="openModal"
            :disabled="disabled"
        ) Рассчитать

        questionnaire-modal(ref="modal")
            .title Расчет SNOT 20

            .block
                .block-question(v-for="(question, id) in questions")
                    .block-question__name {{id}}. {{ question.name }}
                    .app-choice-group
                        app-choice(
                            v-for="variant in variants"
                            v-model="question.value"
                            type="radio"
                            :label="variant.name"
                            :radio-value="variant.value"
                            :error="$v.$dirty && $v.questions.$each.$iter[id].value.$invalid"
                        )
                    app-choice(
                        v-model="question.significant"
                        type="checkbox"
                        label="Наиболее значимая проблема"
                        :error="$v.$dirty && $v.questions.$each.$iter[id].significant.$invalid"
                        :disabled="!question.significant && significantQuestionsLength === 5"
                    )

            .bottom
                .result(v-if="tempResult !== null") SNOT 20 = <b>{{ tempResult }}</b>
                app-button(
                    large
                    @click="calculate"
                ) Рассчитать
                app-button(
                    large
                    color="white"
                    :disabled="tempResult === null"
                    @click="save"
                ) Сохранить рассчет
</template>

<script>
import questionnaireMixin from '@/mixins/questionnaireMixin';

import { required } from 'vuelidate/lib/validators';

export default {
    name: 'questionnaire-snot20',

    mixins: [questionnaireMixin],

    data: () => ({
        questions: {
            1: { name: 'Необходимость высморкаться' },
            2: { name: 'Чихание' },
            3: { name: 'Отделяемое из носа' },
            4: { name: 'Кашель' },
            5: { name: 'Постназальные стекание из носа' },
            6: { name: 'Густое отделяемое из носа' },
            7: { name: 'Ощущение заложенности в ушах' },
            8: { name: 'Головокружение' },
            9: { name: 'Боль в ухе' },
            10: { name: 'Боль / давление в лице' },
            11: { name: 'Трудности с засыпанием сна' },
            12: { name: 'Ночные пробуждения' },
            13: { name: 'Недостаток хорошего ночного сна' },
            14: { name: 'Пробуждение усталым' },
            15: { name: 'Утомляемость, усталость' },
            16: { name: 'Сниженная продуктивность' },
            17: { name: 'Сниженная концентрация' },
            18: { name: 'Ощущение разочарования, беспокойства, раздражения' },
            19: { name: 'Ощущение печали' },
            20: { name: 'Ощущение смущения' },
        },

        variants: [
            { name: 'Нет проблемы', value: 0 },
            { name: 'Незначительная проблема', value: 1 },
            { name: 'Легкая проблема', value: 2 },
            { name: 'Умеренная проблема', value: 3 },
            { name: 'Тяжелая проблема', value: 4 },
            { name: 'Настолько тяжелая проблема, насколько это возможно', value: 5 },
        ],
    }),

    validations: {
        questions: {
            $each: {
                value: { required },
                significant: {
                    required(value) {
                        return value || this.significantQuestionsLength >= 1;
                    },
                },
            },
        },
    },

    computed: {
        significantQuestions() {
            return Object.values(this.questions).filter(q => q.significant);
        },

        significantQuestionsLength() {
            return this.significantQuestions.length;
        },
    },

    created() {
        for (let id in this.questions) {
            this.$set(this.questions[id], 'value', null);
            this.$set(this.questions[id], 'significant', false);
        }
    },

    methods: {
        calculate() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                this.$refs.modal.scrollToInvalidField();
                return;
            }

            this.tempResult = Object.values(this.questions).reduce((sum, question) => sum + question.value, 0);
        },

        save() {
            const significantQuestionsNames = this.significantQuestions
                .map(q => q.name)
                .join(', \n')
                .toLowerCase();

            this.result = this.tempResult;
            this.$emit('setProblems', significantQuestionsNames);

            this.$refs.modal.close();
        },
    },
};
</script>

<style scoped lang="scss">
.questionnaire-snot20 {
    .result-field {
        width: rem(105px);

        @include mobile_or_P {
            width: rem(200px);
            margin-right: 1.5rem;
        }
    }

    .block-question {
        margin-bottom: rem(24px);

        .app-choice-group {
            margin-bottom: rem(8px);
        }
    }
}
</style>
